


'use strict';

/**
 * Shows product info link data
 * @param {Object} element - action button.
 * @param {boolean} isMobile - True indicates the action is on mobile device.
 */
function handleProductInfoLinkOpen(element, isMobile) {
    const $infoLinkData = $(element).data('info-link-data');
    const componentId = $(element).data('target');
    const $bottomSheet = $(componentId);

    $bottomSheet.find('.infolink-title').empty().html($infoLinkData.modalTitle);
    $bottomSheet.find('.infolink-body').empty().html($infoLinkData.modalContent);

    if (isMobile) {
        $(document).trigger('openBottomSheetRequest', { targetId: componentId });
    }
    else {
        $bottomSheet.modal('show');
    }
}

/**
 * Initialize iniProductLink buttons listener.
 */
function initProductInfoLinksTrigger() {
    $(document).on('click', '.info-links-pdp .infolink-trigger', function () {
        const isMobile = $(this).data('is-mobile');
        handleProductInfoLinkOpen(this, isMobile);
    });
}

module.exports = {
    initProductInfoLinksTrigger: initProductInfoLinksTrigger
}
